import { inject, Injectable, isDevMode } from "@angular/core";
import { User } from "@domain/user/user";
import { UserService } from "@domain/user/user.service";
import { environment } from "@environments/environment";
import { ProductFruitsClientOptions } from "@odx/product-fruits";
import { filter, map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class ProductFruitsConfigService {
  private userService = inject(UserService);

  config$: Observable<ProductFruitsClientOptions> = this.userService.user$.pipe(
    filter((user): user is User => !!user && !user.readOnlyAccess && !!user.role && !!user.productFruitsHmac),
    map((user) => ({
      workspaceCode: environment.productFruitsWorkspaceCode,
      language: "en",
      user: {
        username: user.email!,
        firstname: user.firstName,
        lastName: user.lastName,
        role: this.setUserRole(user.role),
        hmac: { hash: user.productFruitsHmac! },
      },
      debug: isDevMode(),
      onError: (err: any) => console.error(err),
    })),
  );

  private setUserRole(role: any) {
    const countryKey = Object.keys(role).find((key) => key.startsWith("user/"));
    return countryKey !== undefined ? role[countryKey] : role.user;
  }
}
